import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/tn-life-logo.svg'
import _imports_1 from '@/assets/images/tn-logo-full.svg'


const _hoisted_1 = { class: "meet" }
const _hoisted_2 = {
  key: 0,
  class: "meet__platform-select"
}
const _hoisted_3 = { class: "meet__platform-container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "meet__logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "meet__logo-image",
    src: _imports_0,
    alt: "TN Life Лого"
  }),
  /*#__PURE__*/_createElementVNode("h1", { class: "meet__logo-text" }, "TN Life")
], -1)
const _hoisted_5 = { class: "meet__platform-header" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "meet__platform-button-title" }, "В браузере", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "meet__platform-button-description" }, " Без загрузки и установки приложения TN Life ", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "meet__platform-button-title" }, "В приложении", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "meet__platform-button-description" }, " Если у вас уже есть приложение TN Life ", -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "meet__platform-button-title" }, "Скачать TN Life", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "meet__platform-button-description" }, " Если у вас ещё нет приложения ", -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "meet__platform-checkbox-container" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "meet__platform-checkbox-label-container" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "meet__platform-checkbox-label" }, "Запомнить выбор"),
  /*#__PURE__*/_createElementVNode("p", { class: "meet__platform-checkbox-description" }, " Изменить выбор можно в настройках профиля TN Life ")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "meet__platform-button-title" }, " Присоединиться ко встрече ", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "meet__platform-button-description" }, " Сразу присоединитесь ко встрече — нужно будет ввести только имя ", -1)
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "meet__platform-button-title" }, " Войти и присоединиться ", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "meet__platform-button-description" }, " Авторизуйтесь, чтобы присоединиться ко встрече ", -1)
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("footer", { class: "meet__platform-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "meet__platform-logo-image",
    src: _imports_1,
    alt: "TN Лого"
  })
], -1)
const _hoisted_24 = {
  key: 1,
  class: "meet__review-page"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "meet__review-page-head" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "meet__review-page-head-image",
    src: _imports_0,
    alt: "TN Life logo"
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "meet__review-page-head-title" }, "TN Life")
], -1)
const _hoisted_26 = { class: "meet__review-page-body" }
const _hoisted_27 = {
  key: 0,
  class: "meet__review-page-stars-container"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("path", { d: "M16 5L20 10L26 13L22 18L22 24L16 23L10 24L10 18L6 13L12 10Z" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("path", { d: "M16 4C16.9217 4 17.778 4.47592 18.2646 5.25863L20.8191 9.3671L25.5158 10.5269C26.4106 10.7479 27.1279 11.4152 27.4127 12.2918C27.6975 13.1683 27.5095 14.1298 26.9155 14.8345L23.7974 18.5335L24.1457 23.3588C24.2121 24.2781 23.7991 25.1665 23.0534 25.7082C22.3078 26.2499 21.3353 26.3682 20.4815 26.0211L16 24.1987L11.5185 26.0211C10.6647 26.3682 9.69222 26.2499 8.94658 25.7082C8.20094 25.1665 7.78791 24.2781 7.85426 23.3588L8.20257 18.5335L5.08454 14.8345C4.49053 14.1298 4.30252 13.1683 4.58733 12.2918C4.87213 11.4152 5.58938 10.7479 6.48416 10.5269L11.1809 9.3671L13.7354 5.25863C14.222 4.47592 15.0783 4 16 4ZM12.873 11.696L7.12348 13.1158L10.9404 17.644L10.514 23.5508L16 21.32L21.486 23.5508L21.0596 17.644L24.8765 13.1158L19.127 11.696L16 6.66667L12.873 11.696Z" }, null, -1)
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = { class: "meet__review-page-body-title" }
const _hoisted_32 = { class: "meet__review-page-body-subtitle" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("img", {
  class: "meet__review-page-footer-image",
  src: _imports_1,
  alt: "TN logo"
}, null, -1)
const _hoisted_35 = {
  key: 2,
  ref: "meetContainer",
  class: "meet__meet-container"
}
const _hoisted_36 = {
  key: 0,
  class: "meet__waiting-container"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "meet__loading-icon" }, null, -1)
const _hoisted_38 = { class: "meet__loading-container" }
const _hoisted_39 = { class: "meet__loading-title" }
const _hoisted_40 = { class: "meet__loading-subtitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_RatingStars = _resolveComponent("RatingStars")!
  const _component_TNTextarea = _resolveComponent("TNTextarea")!
  const _component_SmartCaptcha = _resolveComponent("SmartCaptcha")!
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    (_ctx.isShowSelectPlatform || _ctx.isShowAuthOptions)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.landingHeaderText), 1),
            (_ctx.isShowSelectPlatform)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.webLink)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "meet__platform-button meet__platform-button_web",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openWebMeeting && _ctx.openWebMeeting(...args)))
                      }, _hoisted_8))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "meet__platform-button meet__platform-button_app",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openAppMeeting && _ctx.openAppMeeting(...args)))
                  }, _hoisted_11),
                  (_ctx.detectedPlatform)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "meet__platform-button meet__platform-button_download",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.downloadAppMeeting && _ctx.downloadAppMeeting(...args)))
                      }, _hoisted_14))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_15, [
                    (_ctx.isShowCheckbox)
                      ? (_openBlock(), _createBlock(_component_Checkbox, {
                          key: 0,
                          modelValue: _ctx.isSaveChoice,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isSaveChoice) = $event)),
                          class: "meet__platform-checkbox"
                        }, null, 8, ["modelValue"]))
                      : _createCommentVNode("", true),
                    _hoisted_16
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.isShowAuthOptions)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("button", {
                    class: "meet__platform-button meet__platform-button_without-auth",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.enterWithoutAuth && _ctx.enterWithoutAuth(...args)))
                  }, _hoisted_19),
                  _createElementVNode("button", {
                    class: "meet__platform-button meet__platform-button_with-auth",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.enterWithAuth && _ctx.enterWithAuth(...args)))
                  }, _hoisted_22)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _hoisted_23
        ]))
      : (_ctx.isReviewPageVisible)
        ? (_openBlock(), _createElementBlock("section", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              (_ctx.review.sent)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.review.stars, (index) => {
                      return (_openBlock(), _createElementBlock("svg", {
                        key: index,
                        class: "meet__review-page-star",
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "32",
                        height: "32",
                        viewBox: "0 0 32 32",
                        fill: "#ff8a0c"
                      }, _hoisted_30))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("h2", _hoisted_31, _toDisplayString(_ctx.reviewTitle), 1),
              _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.reviewSubtitle), 1),
              (!_ctx.review.sent)
                ? (_openBlock(), _createBlock(_component_RatingStars, {
                    key: 1,
                    modelValue: _ctx.review.stars,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.review.stars) = $event)),
                    class: "meet__review-page-rating-stars",
                    disabled: _ctx.isConfirmingCaptcha
                  }, null, 8, ["modelValue", "disabled"]))
                : _createCommentVNode("", true),
              (!_ctx.review.sent)
                ? (_openBlock(), _createBlock(_component_TNTextarea, {
                    key: 2,
                    modelValue: _ctx.review.comment,
                    "onUpdate:modelValue": [
                      _cache[7] || (_cache[7] = ($event: any) => ((_ctx.review.comment) = $event)),
                      _ctx.updateCommentHandler
                    ],
                    error: _ctx.commentErrorMessage,
                    class: "meet__review-page-textarea",
                    disabled: _ctx.isConfirmingCaptcha,
                    "min-height": 113,
                    placeholder: "Оставьте комментарий по качеству работы сервиса или предложите варианты по его улучшению"
                  }, null, 8, ["modelValue", "error", "disabled", "onUpdate:modelValue"]))
                : _createCommentVNode("", true),
              (_ctx.isConfirmingCaptcha && !_ctx.review.sent)
                ? (_openBlock(), _createBlock(_component_SmartCaptcha, {
                    key: 3,
                    class: "meet__review-page-captcha",
                    sitekey: _ctx.captchaSiteKey,
                    callback: _ctx.captchaCallback
                  }, null, 8, ["sitekey", "callback"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                    (!_ctx.review.sent)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "meet__review-page-button meet__review-page-button_rate",
                          disabled: _ctx.reviewButtonDisabled,
                          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.confirmCaptcha && _ctx.confirmCaptcha(...args)))
                        }, " Оценить ", 8, _hoisted_33))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: _normalizeClass(["meet__review-page-button meet__review-page-button_back-to-meeting", { 'meet__review-page-button_sent': _ctx.review.sent }]),
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.reenterMeeting && _ctx.reenterMeeting(...args)))
                    }, " Обратно во встречу ", 2)
                  ], 64))
            ]),
            _hoisted_34
          ]))
        : (_openBlock(), _createElementBlock("section", _hoisted_35, [
            (_ctx.isWaitingForEnter || !!_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("section", _hoisted_36, [
                  _hoisted_37,
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("h1", _hoisted_39, _toDisplayString(_ctx.loadingTitle), 1),
                    _createElementVNode("h2", _hoisted_40, _toDisplayString(_ctx.loadingSubtitle), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_Popup, {
              show: !!_ctx.errorMessage,
              "data-test-id": "error-meet-popup",
              title: _ctx.errorPopupTitle,
              description: _ctx.errorMessage,
              onClose: _ctx.goToHomepage
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  "data-test-id": "go-back-button",
                  class: "popup__button button button_link",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.goToHomepage && _ctx.goToHomepage(...args)))
                }, " На главную страницу "),
                _createElementVNode("button", {
                  "data-test-id": "join-again-button",
                  class: "popup__button button",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.errorButtonClickHandler && _ctx.errorButtonClickHandler(...args)))
                }, " Подключиться ещё раз ")
              ]),
              _: 1
            }, 8, ["show", "title", "description", "onClose"])
          ], 512))
  ]))
}